(() => {
  'use strict';

  if (window.__majesticTimelineInitialized) return;
  window.__majesticTimelineInitialized = true;

  const SECTION_SELECTOR = '[data-timeline-section]';
  const REVEAL_SELECTOR = '[data-timeline-section][data-timeline-reveal="true"]';
  const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

  const reveal = (section) => {
    if (!(section instanceof HTMLElement)) return;
    section.classList.add('is-visible');
  };

  const revealStaticSections = (scope = document) => {
    scope.querySelectorAll(SECTION_SELECTOR).forEach((section) => {
      if (section.dataset.timelineReveal === 'false') reveal(section);
    });
  };

  const canAnimate = !window.matchMedia(REDUCED_MOTION_QUERY).matches;
  const hasIntersectionObserver = 'IntersectionObserver' in window;

  let observer = null;

  if (canAnimate && hasIntersectionObserver) {
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          reveal(entry.target);
          observer.unobserve(entry.target);
        });
      },
      {
        threshold: 0.15,
        rootMargin: '0px 0px -8% 0px'
      }
    );
  }

  const bindRevealSections = (scope = document) => {
    scope.querySelectorAll(REVEAL_SELECTOR).forEach((section) => {
      if (section.dataset.timelineBound === 'true') return;
      section.dataset.timelineBound = 'true';

      if (!canAnimate || !observer) {
        reveal(section);
        return;
      }

      observer.observe(section);
    });
  };

  const boot = (scope = document) => {
    revealStaticSections(scope);
    bindRevealSections(scope);
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        boot(document);
      },
      { once: true }
    );
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (!(event.target instanceof Element)) return;
    boot(event.target);
  });
})();
